//@ts-nocheck
import { Route, Routes } from "react-router-dom";
import DashboardLayout from "../layouts/DashboardLayout";
import { AuthorList } from "../pages/Author/AuthorList";
import { CreateAuthor } from "../pages/Author/CreateAuthor";
import { EditAuthor } from "../pages/Author/EditAuthor";
import BlogOverview from "../pages/BlogOverview";
import { CategoryList } from "../pages/Category/CategoryList";
import { CreateCategory } from "../pages/Category/CreateCategory";
import { EditCategory } from "../pages/Category/EditCategory";
import PageNotFound from "../pages/ErrorPage/PageNotFound";
import CreateBlog from "../pages/Post/CreatePost";
import { EditPost } from "../pages/Post/EditPost";
import { BlogList } from "../pages/Post/PostList";
import { CreateTag } from "../pages/Tags/CreateTag";
import { EditTag } from "../pages/Tags/EditTags";
import { TagList } from "../pages/Tags/TagList";
import PrivateRoute from "./PrivateRoute";
//@ts-ignore
import {
  AccessControl,
  PermissionRequired,
} from "@careinfo/permission-required";
import { WelcomeRouterService } from "@careinfo/welcome-page-service";
import { getKey } from "../helpers/sessionKey";

const Router = () => {
  const shouldShowWelcome = getKey("shouldShowWelcome");
  return (
    <Routes>
      <Route
        element={
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        }
      >
        <Route
          path={"/blog"}
          element={
            shouldShowWelcome === "true" || shouldShowWelcome === null ? (
              <WelcomeRouterService />
            ) : (
              <BlogOverview />
            )
          }
        />

        <Route
          path={"/blog/post"}
          element={
            <AccessControl
              children={<BlogList />}
              allowedPermissions={["can_view_blogs"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route path={"/blog/overview"} element={<BlogOverview />} />
        <Route
          path={"/blog/post/create"}
          element={
            <AccessControl
              children={<CreateBlog />}
              allowedPermissions={["can_create_blogs"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route path={"/blog/author"} element={<AuthorList />} />
        <Route path={"/blog/author/create"} element={<CreateAuthor />} />
        <Route
          path={"/blog/category"}
          element={
            <AccessControl
              children={<CategoryList />}
              allowedPermissions={["can_view_categories"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/blog/category/create"}
          element={
            <AccessControl
              children={<CreateCategory />}
              allowedPermissions={["can_create_categories"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route path={"/blog/tag"} element={<TagList />} />
        <Route path={"/blog/tag/create"} element={<CreateTag />} />
        <Route
          path={"/blog/post/edit/:id"}
          element={
            <AccessControl
              children={<EditPost />}
              allowedPermissions={["can_update_blogs"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route path={"/blog/author/edit/:id"} element={<EditAuthor />} />
        <Route
          path={"/blog/category/edit/:id"}
          element={
            <AccessControl
              children={<EditCategory />}
              allowedPermissions={["can_update_categories"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route path={"/blog/tag/edit/:id"} element={<EditTag />} />
        <Route path="/*" element={<PageNotFound />} />
      </Route>
    </Routes>
  );
};

export default Router;
